module.exports = __webpack_public_path__ + "img/forecast_filters.5d997fb7.png";